export default "__VITE_ASSET__5cfe111a__"